import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';

/**
 * Trata falhas de autorização das chamadas à API da plataforma: em 401 (token
 * expirado/revogado) limpa o usuário e leva à tela de sessão expirada; em 403
 * (papel sem permissão) leva à tela de acesso negado. Só atua em respostas de
 * `environment.apiUrl` — outras origens (Cognito, assets) seguem intactas.
 */
export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const apiUrl = environment.apiUrl;
  if (!apiUrl || !req.url.startsWith(apiUrl)) {
    return next(req);
  }

  const router = inject(Router);
  const auth = inject(AuthService);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 401) {
          auth.user.set(null);
          void router.navigateByUrl('/sessao-expirada');
        } else if (error.status === 403) {
          void router.navigateByUrl('/acesso-negado');
        }
      }
      return throwError(() => error);
    }),
  );
};
